import { useRef } from 'react';
import CardOverlay, { CardFooterContent, CardBonuses } from './CardOverlay';
import { useImages } from '../context/ImageContext';
import { useHover } from '../utils/Mobile';
const TechnologyConverter = require('@tta/engine/Utilities/Converters/TechnologyConverter');
const TerritoryEffects = require('@tta/engine/Constants/Territories/TerritoryEffects');
const { GetCardColor } = require('./Utilities/Utilities');

// Something small in the side strip, with the full card on hover
function Hoverable({card, className, style, children})
{
    const [show, setShow, hoverProps] = useHover();
    const ref = useRef(null);
    return (
        <div>
            <div ref={ref} className={className} style={style} {...hoverProps}>{children}</div>
            {card && <CardOverlay ShowOverlay={show} ComponentRef={ref} card={card} callback={() => {}} OnClose={() => setShow(false)}/>}
        </div>
    );
}

// A special technology as a tile with its kind's icon (hover for the card)
const SpecialTechImages = { Civil: "Civil", Construction: "Construction", Colonization: "Exploration", Military: "Military" };

export function SpecialTechTile({tech})
{
    const { images } = useImages();
    const image = images[SpecialTechImages[tech.type]] ?? images.Civil;
    return (
        <Hoverable card={TechnologyConverter(tech.name)} className="tta-special-tile">
            <img src={image.src} alt={tech.name}/>
        </Hoverable>
    );
}

// A colony as a pill in its card's color showing what it gives while held (hover for the card). Blue tokens it takes
// away (Vast, Autonomous Territory) are left off: only on the card, as the pill would look clumsy with them
export function ColonyPill({colony})
{
    const { images } = useImages();
    const bonuses = TerritoryEffects[colony.name]?.bonuses(colony);
    const shown = bonuses && Object.fromEntries(Object.entries(bonuses).filter(([stat, value]) => !(stat === 'blueTokens' && value < 0)));
    return (
        <Hoverable card={colony} className="tta-colony-pill" style={{ backgroundColor: GetCardColor(colony) }}>
            {shown ? <CardBonuses card={{ bonuses: shown }} images={images}/> : <CardFooterContent card={colony} images={images}/>}
        </Hoverable>
    );
}

// A war this player is in, for the status bar: a badge with the rival's name (hover for the war card)
export function WarBadge({war, rival, color})
{
    return (
        <Hoverable card={war.card} className="tta-war-badge">
            <span aria-hidden>⚔</span> <span style={{ color }}>{rival}</span>
        </Hoverable>
    );
}
